module.exports = __webpack_public_path__ + "img/pro_capture1.10a46416.png";